import { configureStore } from '@reduxjs/toolkit';
import selectedDevicesReducer from './features/selectDevicesSlice';
import regionReducer from "./store/regionSlice";

const store = configureStore({
    reducer: {
        selectedDevices: selectedDevicesReducer,
        region: regionReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;